// extracted by mini-css-extract-plugin
export default {"container":"mP-z","dimension":"nP-z","dimensionLabels":"oP-z"};